module.exports = __webpack_public_path__ + "img/mobile-2.0.1.0_202602051651.png";